import { render, staticRenderFns } from "./ApprovalPendingList.vue?vue&type=template&id=52e85e14&"
import script from "./ApprovalPendingList.vue?vue&type=script&lang=js&"
export * from "./ApprovalPendingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports